import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { MarketingProvider } from '../../providers/marketing/marketing';
import { RouteProvider } from '../../providers/route/route';
import { LoggerProvider, LoggerLevel, LoggerEvent } from '../../providers/logger/logger';
import { Platform } from 'ionic-angular';
import { ColorProvider } from '../../providers/color/color';
import * as $ from 'jquery'

@Component({
  selector: 'rmt-content',
  templateUrl: 'rmt-content.html'
})
export class RmtContentComponent {
  @ViewChild('container', { read: ElementRef }) container;
  @ViewChild('headerLarge', { read: ElementRef }) headerLarge;
  @Input() pageName;
  @Input() marketings;
  @Input() newInputStyle: boolean = false;
  @Input() isLoggingDisabled: boolean = false;
  @Input() prepareChilds: boolean = true;
  @Input() headerTitle;
  @Input() customClass: string = '';
  @Input() noHeaderIcon: boolean = false;
  @Input() isScrollForHeader: boolean = true;
  marketingCards;
  marketingTop;
  marketingBottom;
  focused = null;
  counterElement = 0;
  inputIdStr = 'Input';
  btnIdStr = 'Btn';
  counterBtnElement = 0;
  headerSmallEl: any = null;
  scroll;

  constructor(private marketingProvider: MarketingProvider,
              private routeProvider: RouteProvider,
              private platform: Platform,
              private elementRef: ElementRef) {
  }

  ngAfterViewInit() {
    if (this.newInputStyle)
      this.container.nativeElement.parentNode.className += ' new-input-style';

    // needs a little delay to ensure that the navcontroller reflects the correct page (i.e. changing tabs)
    window.setTimeout(() => {
      this.init();
    }, 200);

    const page = $(this.container.nativeElement).parents('.ion-page');
    if (page && page.length > 0) {
      const footer = page[0].getElementsByTagName('rmt-footer');
      if (footer && footer.length > 0)
        $(this.container.nativeElement.parentNode).addClass('bottom-notch');
    }

      const scrolls = $(this.container.nativeElement).parents('.scroll-content');
      if (scrolls && scrolls.length > 0) {
        this.scroll = scrolls.get(0);
        this.setScroll();
    }
  }

  setScroll() {
    if (this.isScrollForHeader) {
      const onscroll = this.scroll.onscroll;
      this.scroll.onscroll = (ev) => {
        if (onscroll)
          onscroll.call(scroll);
          if (this.platform.is('ios')) {
            if (this.focused)
              this.checkCaret(this.focused, scroll);
          }

        if (this.headerTitle && ev && ev.target) {
          const scrollOffset = ev.target.scrollTop;
          if (scrollOffset > 0) {
            const opacity = Math.min(scrollOffset / this.headerLarge.nativeElement.offsetHeight, 1.0);
            if (!this.headerSmallEl) {
              const content = $(this.container.nativeElement).parents('ion-content');
              if (content && content.length > 0) {
                this.headerSmallEl = document.createElement('div');
                this.headerSmallEl.innerText = this.headerTitle;
                this.headerSmallEl.className = 'content-header-title-small';
                this.headerSmallEl.style.height = ev.target.style.marginTop; // reflects the height of the header bar
                if (this.noHeaderIcon) {
                  const topbarNotch = window.getComputedStyle(document.documentElement).getPropertyValue("--top-bar");
                  const topbarNotchVal = parseInt(topbarNotch.slice(0, -2));
                  this.headerSmallEl.style.backgroundColor = ColorProvider.getColorValue("--gray-200");
                  const headerTop = topbarNotchVal > 0 ? (topbarNotchVal + 24) + "px" : (topbarNotchVal + 54) + "px";
                  this.headerSmallEl.style.height = headerTop;

                  if (this.platform.is("ios")) {
                    this.headerSmallEl.style.paddingTop = "20px";
                  } else {
                    this.headerSmallEl.style.paddingTop = topbarNotchVal > 0 ? "20px" : "0px";
                  }
                }
                content.get(0).parentNode.appendChild(this.headerSmallEl)
              }
            }
            if (this.headerSmallEl)
              this.headerSmallEl.style.opacity = opacity;
            this.setHeaderOpacity(1.0 - opacity);
            if (opacity > 0.30) {
              this.setStepperStyle("30px");
            } else {
              this.setStepperStyle("0px");
            }
          }
          else {
          if (this.headerSmallEl) {
            this.headerSmallEl.style.opacity = 0.0;
            this.setStepperStyle("0px")
          }
            this.setHeaderOpacity(1.0);
          }
        }
        else {
          if (this.headerSmallEl) {
            this.headerSmallEl.style.opacity = 0.0;
            this.setStepperStyle("0px")
          }
          this.setHeaderOpacity(1.0);
        }
      }
    }
  }

  setStepperStyle(marginTop="0px"){
    let stepprCollection = document.getElementsByTagName("rmt-steps");
    if(stepprCollection && stepprCollection.length > 0){
      for( var i = 0; i < stepprCollection.length; i++ ){
        (<HTMLElement>stepprCollection[i]).style.marginTop = marginTop;
     }
    }
  }



  async init() {
    try {
      if (this.marketings) {
        this.marketingCards = this.marketings.filter((marketing) => marketing.target_id === '1');
        this.marketingTop = this.marketings.filter((marketing) => marketing.target_id === '2');
        this.marketingBottom = this.marketings.filter((marketing) => marketing.target_id === '3');
      }
      else {
        if (!this.pageName)
          this.pageName = await this.routeProvider.getLastActivePageAsync();
        this.marketingCards = await this.marketingProvider.getCardsForPage(this.pageName);
        this.marketingTop = await this.marketingProvider.getTopForPage(this.pageName);
        this.marketingBottom = await this.marketingProvider.getBottomForPage(this.pageName);
      }
    }
    catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.ComponentException, 'Failed to initialize RmtContentComponent');
    }
  }

  ngDoCheck() {
    if (this.prepareChilds)
      this.processPrepareChilds();
  }

  ngOnChanges() {
    if (this.headerSmallEl && this.headerSmallEl.innerText !== this.headerTitle)
      this.headerSmallEl.innerText = this.headerTitle;
  }

  processPrepareChilds() {
    const pages = $(this.elementRef.nativeElement).parents('.ion-page');
    if (!pages || pages.length === 0)
      return;

    const page = pages.get(0);
    const inputs = page.getElementsByTagName('input');
    for (let i = 0; i < inputs.length; i++) {
      const input: any = inputs[i];
      if (input.onContentAdjusted)
        continue;

      // set pattern after view init, otherwise it messes up the validator in AOT
      if (input.type === 'number')
        input.setAttribute('pattern', '\\d*');
      let nameID = input.id;
      if (!nameID || nameID == '') {
        const itemsList = $(input).parents('ion-item');
        if (itemsList && itemsList.length > 0) {
          const item = itemsList.get(0);
          const inputsList = item.getElementsByTagName('ion-input')
          if (inputsList && inputsList.length > 0 && !inputsList[0].hasAttribute('id')) {
            let extraPartName: any = this.counterElement;

            if (inputsList[0].hasAttribute('formcontrolname'))
              extraPartName = inputsList[0].getAttribute('formcontrolname');

            else if (inputsList[0].parentElement.hasAttribute('formcontrolname'))
              extraPartName = inputsList[0].parentElement.getAttribute('formcontrolname');

            else if (inputsList[0].parentElement.parentElement.hasAttribute('formcontrolname'))
              extraPartName = inputsList[0].parentElement.parentElement.getAttribute('formcontrolname');

            inputsList[0].id = page.tagName + this.inputIdStr + extraPartName;
            this.counterElement++
          }

        }
      }

      input.onContentAdjusted = true;
      const onfocus = input.onfocus;
      const onblur = input.onblur;
      const onkeypress = input.onkeypress;
      input.onfocus = () => {
        let name = input.placeholder;
        if (!name) {
          name = 'Unknown'
          const items = $(input).parents('ion-item');
          if (items && items.length > 0) {
            const item = items.get(0);
            const labels = item.getElementsByTagName('ion-label');
            if (labels && labels.length > 0) {
              const label: any = labels[0];
              name = label.innerText;
            }
          }
        }
        LoggerProvider.log(this, LoggerLevel.Trace, LoggerEvent.UIEnter, 'Focus input: ' + name);
        if (onfocus)
          onfocus.call(input);

        // delay one frame so it doesn't clash with onblur
        window.requestAnimationFrame(() => {
          this.focused = input;
          this.focusInput(input);
        });
      };
      if (!this.platform.is('ios')) {
        input.onkeypress = () => {
          if (onkeypress)
            onkeypress.call(input);
          this.focusInput(input);
        };
      }
      input.onblur = () => {
        if (this.focused)
          this.focused.style.caretColor = null;
        this.focused = null;

        if (onblur)
          onblur.call(input);

        if (!this.platform.is('ios')) {
          // delay one frame so it doesn't obstruct a click with this padding
          window.requestAnimationFrame(() => {
            this.elementRef.nativeElement.style.paddingBottom = '0px';
          });
        }
      }
    }

    const buttons = page.getElementsByTagName('button');
    for (let i = 0; i < buttons.length; i++) {
      const button: any = buttons[i];
      if (button.onContentAdjusted)
        continue;
      let nameID = button.id;
      // console.log('role: '+button.getAttribute('role'));
      // console.log('nameID: '+nameID);
      if (!nameID || nameID == '') {
        let extraPartName: any = this.counterBtnElement;

        if (button.hasAttribute('formcontrolname'))
          extraPartName = button.getAttribute('formcontrolname');
        else if (button.parentElement.hasAttribute('formcontrolname'))
          extraPartName = button.parentElement.getAttribute('formcontrolname');

        else if (button.parentElement.parentElement.hasAttribute('formcontrolname'))
          extraPartName = button.parentElement.parentElement.getAttribute('formcontrolname');
        else if (button.parentElement.parentElement.parentElement.hasAttribute('formcontrolname'))
          extraPartName = button.parentElement.parentElement.getAttribute('formcontrolname');
        // console.log('extraPartName'+extraPartName);
        button.id = page.tagName + this.btnIdStr + extraPartName;
        // console.log('page Name = '+page.tagName);
        //   console.log('Btn ID = '+button.id);

        this.counterBtnElement++;
      }
      button.onContentAdjusted = true;
      const onclick = button.onclick;
      button.onclick = () => {
        if (!this.isLoggingDisabled) {
          LoggerProvider.log(this, LoggerLevel.Trace, LoggerEvent.UIClick, 'Clicked button: ' + button.innerText.substr(0, 30));
          if (onclick)
            onclick.call(button);
        }
      };
    }

    const ionbuttons = page.getElementsByTagName('ion-buttons');
    for (let i = 0; i < ionbuttons.length; i++) {
      const ionbutton = ionbuttons[i];
      for (let c = 0; c < ionbutton.childNodes.length; c++) {
        const button: any = ionbutton.childNodes[c];
        if (button.onContentAdjusted)
          continue;

        button.onContentAdjusted = true;
        const onclick = button.onclick;
        button.onclick = () => {
          let name = button.innerText;
          if (!name || name.length === 0) {
            const icons = button.getElementsByTagName('ion-icon')
            if (icons && icons.length > 0)
              name = icons[0].getAttribute('name');
          }
          LoggerProvider.log(this, LoggerLevel.Trace, LoggerEvent.UIClick, 'Clicked button: ' + name);
          if (onclick)
            onclick.call(button);
        };
      }
    }
  }

  getTop(input, target) {
    let top = 0;
    let el = input;
    while (el && el !== target) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    return top;
  }

  checkCaret(input, scroll) {
    if (!input)
      return false;
    const scrolls = $(input).parents('.scroll-content');
    if (!scrolls || scrolls.length === 0) // check if the input is really part of the scroll content (i.e. searchbar in country picker is in fixed content)
      return false;

    const top = this.getTop(input, scroll) - scroll.scrollTop;
    if (top <= -2) {
      this.focused.style.caretColor = 'transparent';
      return false;
    } else {
      this.focused.style.caretColor = null;
      return true;
    }
  }

  scrollToTop() {
    const scrolls = $(this.container.nativeElement).parents('.scroll-content');
    if (scrolls && scrolls.length > 0)
      scrolls[0].scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  focusInput(input) {
    const scrolls = $(input).parents('.scroll-content');
    if (!scrolls || scrolls.length === 0)
      return;

    const scroll = scrolls.get(0);
    if (this.platform.is('ios')) {
      this.checkCaret(this.focused, scroll);

      // on iOS check if the automatic scrolling to input worked and otherwise scroll manually to the input
      window.setTimeout(() => {
        const top = this.getTop(input, scroll) - scroll.scrollTop;
        let height = scroll.offsetHeight;
        if (!scroll.style.marginBottom) {
          const page = $(scroll).parents('.ion-page');
          if (page && page.length > 0) {
            const footer: any = page[0].getElementsByTagName('rmt-footer');
            if (footer && footer.length > 0 && footer[0].childNodes && footer[0].childNodes.length > 0) {
              const footerChild: any = footer[0].childNodes[0];
              height -= footerChild.offsetHeight;
            }
          }
        }
        const caretVisible = this.checkCaret(this.focused, scroll);
        if (((top + input.offsetHeight) >= height) || !caretVisible) {
          LoggerProvider.debug(this, 'Correct scrolling');

          // double check that no scrolling is already active
          let offsetTop = scroll.offsetTop;
          window.setTimeout(() => {
            if (offsetTop === scroll.offsetTop)
              this.scrollToInput(input);
          }, 100);
        }
      }, 400);
    }
    else
      this.scrollToInput(input);
  }

  scrollToInput(input, offset = 100) {
    const scrolls = $(input).parents('.scroll-content');
    if (!scrolls || scrolls.length === 0)
      return;

    // don't play around with padding bottom and scrolling in an actionsheet since it will only create disruption
    const actionsheet = $(input).parents('.rmt-actionsheet-modal');
    if (actionsheet && actionsheet.length > 0)
      return;

    this.scroll = scrolls.get(0);
    const scrolloffset = $(this.scroll).offset();
    let top = this.getTop(input, this.scroll);
    top -= offset;

    const contentheight = $(this.elementRef.nativeElement).height();
    const windowheight = window.innerHeight - scrolloffset.top;
    const missing = contentheight - top - windowheight;
    if (missing < 0)
      this.elementRef.nativeElement.style.paddingBottom = (missing * -1) + 'px';
    else
      this.elementRef.nativeElement.style.paddingBottom = '0px';

    this.scroll.scrollTo({ left: 0, top: top, behavior: 'smooth' });
    this.setScroll();
  }

  getMarketingButtons(buttons) {
    const buttonTexts = [];
    for (let i = 0; i < buttons.length; i++) {
      buttonTexts.push(buttons[i].text);
    }
    return buttonTexts;
  }

  processMarketingButton(marketing, buttonIndex) {
    this.marketingProvider.processButton(marketing, buttonIndex);
  }

  setHeaderOpacity(opacity){
    if(this.headerLarge && this.headerLarge.nativeElement){
      this.headerLarge.nativeElement.style.opacity = opacity;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-content/rmt-content.ts